import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";

import styled from "styled-components";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";

const LayoutCardWrapper = styled.div`
	border-radius: 16px;
	display: flex;
	width: 100%;
	padding-right: 10px;

`;

const LayoutCardsWrapper = styled("div")({
	alignItems: "center",
	display: "flex",
	flexDirection: "column",
	height: "100%",
	justifyContent: "flex-start",
	width: "100%",
});

function RelatorioMsl({ app, config }) {

	const [selectedValue, setSelectedValue] = useState("Regional");

    const handleChange = (event) => {
      if (event.target.value) {
        app.field("Desc_MSL_REL").selectMatch(event.target.value);
        setSelectedValue(event.target.value);
      }
    };

  return (
    <>
      <h2 className="container-title">Visão: </h2>
      <FormControl className="container-form-control">
          <RadioGroup
            row
            value={
              selectedValue
            }
            onChange={
              handleChange
            }
            sx={{marginLeft: "20px", marginBottom: "16px"}}
          >
            <FormControlLabel
             value="Regional"
             control={
               <Radio
               size="small"
               sx={{
                 color: "#ff007f",
                 '&.Mui-checked': {
                   color: "#dd007f"
                  }
                }}
                  />
                }
              label="Regional"
            />

            <FormControlLabel
             value="Regional/Marca"
             control={
               <Radio
               size="small"
               sx={{
                 color: "#ff007f",
                 '&.Mui-checked': {
                   color: "#dd007f"
                  }
                }}
                />
              }
              label="Regional/Marca"
            />

            <FormControlLabel
             value="DB"
             control={
               <Radio
               size="small"
               sx={{
                 color: "#ff007f",
                 '&.Mui-checked': {
                   color: "#dd007f"
                  }
                }}
                />
              }
              label="DB"
            />

            <FormControlLabel
             value="Categoria/Segmento AR"
             control={
               <Radio
               size="small"
               sx={{
                 color: "#ff007f",
                 '&.Mui-checked': {
                   color: "#dd007f"
                  }
                }}
                />
              }
              label="Categoria/Segmento AR"
            />

          </RadioGroup>
      </FormControl>

      <LayoutCardWrapper>
        <LayoutCardsWrapper>
          <Grid container rowGap={2}>
            <LayoutCardWrapper style={{ height: "553px", paddingLeft: '10px'}} >

              <Card
                app={app}
                style={{ width: "100%" }}
                exportTable
                exportTableId="aVkPuq"
                className={"container-table"}
              >

                <NativeObject
                  app={app}
                  key="aVkPuq"
                  reference={{ id: "aVkPuq" }}
                />
              </Card>
            </LayoutCardWrapper>

          </Grid>
        </LayoutCardsWrapper>
      </LayoutCardWrapper>

    </>
  )
}


RelatorioMsl.defaultProps = {
	app: null,
	config: {},
};

RelatorioMsl.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default RelatorioMsl;
